<div class="progress-wrapper" [hidden]="!show">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
